import type { AccountIdentity } from '@/bindings/AccountIdentity'

/** Platform users carry no phone; every other account shape is an `AccountIdentity`. */
type Nameable = Omit<AccountIdentity, 'phone'> & { phone?: string | null }

/** Name, else the identifier the account was reached through, else the id. */
export function accountName(user: Nameable): string {
  return [user.first_name, user.last_name].filter(Boolean).join(' ') || user.phone || user.email || user.id
}
